import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './SharePrice.css';
import { format, parseISO } from 'date-fns';
import {  useParams } from "react-router-dom";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'
function SharePrice() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [co_code, setco_code] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [nameCom, setNameCom] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const [data, setData] = useState([]);
    const { getCompName } = useParams();
    // const [valuebtn, setValueBtn] = useState("desc");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        setloadingshow(true)
        if(co_code != ''){
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "Company-Chart";
            fetch(`${getUrl}/${groupValue}/${co_code}/1M`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    setData(getData.sort().reverse())
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "Company-Chart";
            fetch(`${getUrl}/${groupValue}/${co_code}/1M`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                    setData(getData.sort().reverse())
                })
                .catch((error) => {
                });
        }
    }
        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue,co_code]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     if (groupValue === "BSE") {
    //         const getUrl = BaseURL + "Company-Chart";
    //         fetch(`${getUrl}/${groupValue}/${compCode}/1M`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);
    //                 // console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     } else {
    //         const getUrl = BaseURL + "Company-Chart";
    //         fetch(`${getUrl}/${groupValue}/${compCode}/1M`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);
    //                 //console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     }
    // }


    return (
        <>
        <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Share Price</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Share Price</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Share Price"/>
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-classShare">
                            {/* <div>
                                <div className='quotes-main-comp'>
                                    <input type="text" placeholder='Enter Company Name' onChange={onChangeHandler} ></input>
                                    {showResults ?
                                        <div className="suggestion">
                                            {suggestions && suggestions.map((suggestion, i) =>
                                                <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                            )}
                                        </div> : ''}
                                </div>
                                <div className='get-quote-btn'>
                                    <button className="goComp-comp" onClick={handleClick}>GO</button>
                                </div>
                            </div> */}
                            {/* <div className='DayUp-table-main'>
                                <div className='DayUp-loser-toggle'>
                                    <button id="desc" value="desc" className={(valuebtn === "desc") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Up</button>
                                    <button id="asc" value="asc" className={(valuebtn === "asc") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Down</button>
                                </div>  */}

                            <div className='share-right'>
                                <div className='share-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="BSE" selected>BSE</option>
                                        <option value="NSE">NSE</option>
                                    </select>
                                </div>
                                {/* <div className='DayUp-inner-select'>
                                        {(groupValue === "BSE") ?
                                            <select onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div> */}
                            </div>
                            {/* <hr className="hrShare"></hr> */}
                            <div className='share-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Date</th>
                                            <th className='text-right'>Close</th>
                                            <th className='text-right'>Open</th>
                                            <th className='text-right'>High</th>
                                            <th className='text-right'>Low</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(groupValue == "BSE") ?
                                        currentTableData && currentTableData.map(
                                            ({ upd_Date, price, open, high, low }) => (
                                                <tr>
                                                    <td className="text-left">{(upd_Date != null) ? (format(parseISO(upd_Date), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{price}</td>
                                                    <td className="text-right">{open}</td>
                                                    <td className="text-right">{high}</td>
                                                    <td className="text-right">{low}</td>


                                                </tr>
                                            )): 
                                            currentTableData && currentTableData.map(
                                                ({ upd_Date, price, open, high, low }) => (
                                                    <tr>
                                                        <td className="text-left">{(upd_Date != null) ? (format(parseISO(upd_Date), 'dd-MMM-yyyy')) : ''}</td>
                                                        <td className="text-right">{price}</td>
                                                        <td className="text-right">{open}</td>
                                                        <td className="text-right">{high}</td>
                                                        <td className="text-right">{low}</td>
    
    
                                                    </tr>
                                                ))
                                            }
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default SharePrice;

